module.exports = __webpack_public_path__ + "static/media/chevron-left-solid.25ac18da.svg";